	/*
	HTML data attributes:
		data-tt-refobj = object ID refrence to a given HTML DOM object
			tooltips - specifies the tooltip object that should appear 			(Optional)
			popups - specifies the popup which should appear 					(Required)
			shields - specifies the in page object which should be shielded 	(Required)
		data-tt-orientation = 'left' or 'right'
			tooltips - specifies the side to which the tooltip should appear	(Required)
			popups - N/A														(N/A)
			shields - N/A														(N/A)
		data-tt-cont = content data of the target
			tooltips - specifies the content of the tooltip						(Required)
			popups - specifies the content of the popup							(Optional)
			shields - N/A														(N/A)
	*/
	
	
	var tooltipFadeOutTimer = null;
	var toolTipActive = true;
	
	function initPopUpsAndToolTips(){
	
		$('.tooltipTarget').on({
            mouseenter: function(event){tooltipOver(event.target);},
            mouseleave: function(event){allToolTipOff();}
        });
		
		$('.customPopup').popup({
			autozindex:true,
			scrolllock:true,
			blur:false//,
			//transition: 'all 0.3s'
		});
		
		$('.videoPopup').popup({
			autozindex:true,
			scrolllock:true,
			blur:true,
			onclose: function(){$('#innerVideoContainer').remove();}//,
			//transition: 'all 0.3s'
		});
		
		$('.regVideoPopup').popup({
			autozindex:true,
			scrolllock:true,
			blur:true,
			onclose: function(){$(location).attr("href", "im2?to=registrationVideoValidatePage&me=registrationVideo&form=regVid");}//,
			//transition: 'all 0.3s'
		});
		
		$('.customPopupQuick').popup({
			autozindex:true,
			scrolllock:true,
			blur:false
		});
		
		$('.tooltipShieldBackDrop').each(function(){
			
			$(this).popup({
				setzindex: true,
				blur: false,
				escape: false,
				tooltipanchor: $('#'+this.getAttribute('data-tt-refobj')),
				autoopen: true,
				type: 'tooltip'
			});
		});
		
		$('.tooltipShield').each(function(){
			$("#"+$(this).attr("id")+"_wrapper").remove();
			$(this).width($('#'+this.getAttribute('data-tt-refobj')).width());
			$(this).height($('#'+this.getAttribute('data-tt-refobj')).height());
			$(this).popup({
				setzindex: true,
				blur: false,
				escape: false,
				tooltipanchor: $('#'+this.getAttribute('data-tt-refobj')),
				type: 'tooltip',
				color: 'white',
				opacity: 0.5,
				autoopen: true
			});
			$(this).css("background","none");
			$('#'+this.getAttribute('data-tt-refobj')).css('opacity','.25');
		});

	}
	
	/*-------------------------------------------
	|				Popups						|
	-------------------------------------------*/
	function pleaseWaitBlocker(){
		$.blockUI({
			message: '<div id="busyWaiting" style="text-align:center;" ><br /> Please Wait,<br /><br /><img src="img/ajax-loaderSpinner.gif" /><br /><br />We Are Finalizing Your Registration <br /><br /></div>'
		});
	}
	
    function openPopUp(obj){
        $('#'+obj.getAttribute('data-tt-refobj')).popup('show');
    }
    function openPopUpById(objId){
        $('#'+objId).popup('show');
    }
    function closePopUp(obj){
        $('#'+obj.getAttribute('data-tt-refobj')).popup('hide');
    }
    function closePopUpById(objId){
        $('#'+objId).popup('hide');
    }
	
	/*-------------------------------------------
	|				ToolTips					|
	-------------------------------------------*/
    function tooltipOver(obj){
		if(!toolTipActive)
			return false;
		allToolTipOff();
		clearTimeout(tooltipFadeOutTimer);
		var orientation = obj.getAttribute('data-tt-orientation');
		var offset;
		if(orientation == 'right')
			offset = 17;
		else
			offset = -22;
	
		$('#custom_tooltip_'+orientation+' .popup_content').text(obj.getAttribute('data-tt-cont'));
        $('#custom_tooltip_'+orientation).popup({
        	autozindex:true,
			offsetleft: offset,
			horizontal:orientation,
			tooltipanchor:obj,autoopen: true,
			type: 'tooltip',
			transition: 'all 0.3s'
		});
		
		tooltipFadeOutTimer = setTimeout(function(){allToolTipOff()},5000);
	}
    function tooltipOff(obj){
        $('#'+obj.getAttribute('data-tt-refobj')).popup('hide');
    }
	function allToolTipOff(){
		$('.toolTipObj').popup('hide');
	}
	function toggleToolTips(){
		toolTipActive = toolTipActive? false: true;
		return toolTipActive;
	}
	function getToolTipStatus(){
		return toolTipActive;
	}